export default __webpack_public_path__ + "static/media/SMSBlast.23c757d4.svg";